module.exports = __webpack_public_path__ + "static/media/stock-receipt.5906dcc1.svg";